import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

export const aiHelper = {
  /* eslint-disable-next-line */
  trackEvent: (reactPlugin: ReactPlugin, eventName: string, eventData: any): void => {
    reactPlugin.trackEvent({ name: eventName }, eventData);
  },
};
